var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tradedata-contains",attrs:{"id":"tradedataContains"}},[_c('Header'),_c('div',{staticClass:"main-outer"},[_c('Left'),_c('Center'),_c('Right')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }